import { useMemo } from 'react';
import { backgroundColorGroups } from '../constants/backgroundColorGroups';

/**
 * Hook to extract CSS variable value from utility class names
 * Uses backgroundColorGroups to find the correct variable mapping
 *
 * @param className - The utility class name (e.g., 'bg-utility-success-500') or it can be
 * { custom: '#000000' } or { custom: 'bg-utility-success-500' }
 * @returns The CSS variable name or null if not found
 */
export const useUtilityVariableFromClassName = (className?: string | { custom: string }) => {
  const cssVariableName = useMemo(() => {
    if (!className) return { isClassName: false, value: '' };

    // Search through all background color groups to find matching className
    for (const group of backgroundColorGroups) {
      const matchingColor = group.colors.find((color) => {
        if (typeof className === 'string') {
          return color.id === className;
        }
        return color.id === className.custom;
      });
      if (matchingColor) {
        return { isClassName: true, value: matchingColor.value };
      }
    }

    if (typeof className === 'object') {
      return { isClassName: false, value: className.custom };
    }

    return { isClassName: false, value: className };
  }, [className]);

  return { variable: cssVariableName };
};
